import { useCallback, useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { Image } from "primereact/image";
import { Dropdown } from "primereact/dropdown";
import { Button } from "primereact/button";
import { InputText } from "primereact/inputtext";
import { InputTextarea } from "primereact/inputtextarea";
import BreadCrumbCustom from "../bread-crumb/bread-crumb";
import { BreadcrumbItem } from "../../interfaces/common/common";
import RouteConstant from "../../constants/route.constants";
import { Card } from "primereact/card";
import { useFormik } from "formik";
import { classNames } from "primereact/utils";
import { Dialog } from "primereact/dialog";
import { useTranslation } from "react-i18next";
import UserAddressService from "../../services/useraddress/useraddress.service";
import GetAddressByLocation from "./location-search/get-location";
import {AdminUserAddress,UserEditAddress,UserEditAddress2,} from "../../models/user-address-model";
import { CountryModel } from "../../models/country-model";
import { StateModel } from "../../models/state-model";
import { CityModel } from "../../models/city-model";
import RoleService from "../../services/role/role-service";
import {AdminUserAddress1,UserEditAddress1,} from "../../models/user-address-model";

const AddOrEditAddressArea = (props: any) => {
  const { id } = useParams();
  // const isEdit: boolean = id !== "0";
  const isEdit: boolean = !!id && id !== "0";
  const [isLocationMapVisible, setIsLocationMapVisible] = useState(false);
  const [countries, setCountries] = useState<CountryModel[]>([]);
  const [latitude, setLatitude] = useState<number | null>(null);
  const [longitude, setLongitude] = useState<number | null>(null);
  const [latLngSelected, setLatLngSelected] = useState<string | null>(null);
  const [locationDetails, setLocationDetails] = useState<
    LocationDetails[] | null
  >(null);
  const [areas, setAreas] = useState<{ id: string | undefined; name: string | undefined }[]>([]); 
  // const [areas, setAreas] = useState<string[]>([]);
  const [subdistricts, setSubdistricts] = useState<string[]>([]);
  const [districts, setDistricts] = useState<string[]>([]);
  const [pinstate, setPinState] = useState<string[]>([]);
  const [pincountry, setPinCountry] = useState<string[]>([]);
  const [selectedCountry, setSelectedCountry] = useState<string>("");
  const updateGpsLocation = useCallback(async (latLng: any) => {
    setIsLocationMapVisible(false);
    setLatLngSelected(latLng);
    updateLatitudeAndLongitude(latLng);
    if (isEdit && latLng && id != null) {
      UserAddressService.updateGPSLocation(parseInt(id), latLng);
    }
  }, []);
  const userId = props.userID;
  const isAdmin = RoleService.isAdmin();
  const [loading, setLoading] = useState(true);
  var navigate = useNavigate();
  const { t } = useTranslation();
  const formik: any = useFormik({
    initialValues: {
      id: "",
      name: "",
      addressLine1: "",
      addressLine2: "",
      landMark: "",
      country: "",
      state: "",
      city: "",
      pincode: "",
      subDistrict: "",
      sameAddressLine1: false,
      areaId: "",
    },
    validate: (data: any) => {
      let errors: any = {};

      if (!data.areaId || data.areaId === "") {
        errors.areaId = t("Please Select Area");
      }

      return errors;
    },

    onSubmit: async (data: any) => {
      let addressData: UserEditAddress1 = {
        userAddressID: data.id,
        address1: data.addressLine1,
        address2: data.addressLine2,
        landmark: data.landMark,
        zipcode: data.pincode,
        gpsLocation: latLngSelected,
        userID: userId,
        areaId: data.areaId
      };
      let adminAddressData: AdminUserAddress1 = {
        userAddressID: data.id,
        address1: data.addressLine1,
        address2: data.addressLine2,
        landmark: data.landMark,
        zipcode: data.pincode,
        gpsLocation: latLngSelected,
        userID: userId,
        areaId: data.areaId
      };
      try {
        if (!isEdit) {
          const response = await UserAddressService.apiuserAddress1(
            addressData
          );
          if (response.isSuccess) {
            navigate(RouteConstant.userAddresses);
          }
        } else {
          if (isAdmin) {
            const userAddress = await UserAddressService.addAdminAddress1(
              adminAddressData
            );
            if (userAddress.isSuccess) {
              // props.setHideAddress(false);
              //  props.RefreshQuery();
              navigate(RouteConstant.userAddresses);
            }
          } else {
            const response = await UserAddressService.editUserAddress(
              addressData
            );
            if (response.isSuccess) {
              navigate(RouteConstant.userAddresses);
            }
          }
        }
      } catch (error) {
        console.error("Error submitting form:", error);
      }
    },
  });
  const updateLatitudeAndLongitude = (location: string) => {
    if (location) {
      try {
        var locationSplit = location.split(",");
        setLatitude(parseFloat(locationSplit[0]));
        setLongitude(parseFloat(locationSplit[1]));
        setLatLngSelected(location);
      } catch {}
    }
  };
  
  useEffect(() => {
    const fetchCountriesAndAddress = async () => {
      if (isEdit && id != null) {
        let addressId: number = parseInt(id);
        await fetchData(addressId);
      }
      setLoading(false);
    };

    fetchCountriesAndAddress();
  }, [id, isEdit]);

  const fetchData = async (addressId: number) => {
    const userAddresses = await UserAddressService.getUserAddress(addressId);
    const userAddress = userAddresses.find(
      (x: any) => x.userAddressID === addressId
    );

    if (userAddress) {
      formik.setValues({
        id: userAddress.userAddressID,
        name: userAddress.userName,
        addressLine1: userAddress.address1,
        addressLine2: userAddress.address2,
        landMark: userAddress.landmark,
        country: userAddress.countryName,
        state: userAddress.stateName,
        areaId: userAddress.areaID,
        area: userAddress.areaName,
        district: userAddress.districtName,
        subDistrict: userAddress.subDistrictName,
        pincode: userAddress.zipcode,
        sameAddressLine1: userAddress.sameAddressLine1,
      });
      formik.setFieldValue("area", userAddress.areaName || "");
      formik.setFieldValue("areaId", userAddress.areaID || "");
      setAreas([{ id: userAddress.areaID, name: userAddress.areaName }]);
      setSubdistricts([userAddress.subDistrictName]);
      setDistricts([userAddress.districtName]);
      setPinState([userAddress.stateName]);
      setPinCountry([userAddress.countryName]);
      formik.setFieldValue("areaId", userAddress.areaId || "");
      formik.setFieldValue("area", userAddress.areaName || "");
    } else {
      if (!RoleService.isAdmin) {
        navigate(RouteConstant.userAddresses);
      }
    }
  };

  const isFormFieldInvalid = (name: any) =>
    !!(formik.touched[name] && formik.errors[name]);
  const getFormErrorMessage = (name: any) => {
    return isFormFieldInvalid(name) ? (
      <small className="p-error">{formik.errors[name]}</small>
    ) : (
      <small className="p-error">&nbsp;</small>
    );
  };
  const breadCrumbItems: BreadcrumbItem = {
    items: [{ label: t("editaddress_breadcrumb_editaddress") }],
    home: { label: t("common_breadcrumb_home") },
    backgroundImage: process.env.PUBLIC_URL + "/assests/images/image-1.jpeg",
    title: t("useraddress_breadcrumb_label"),
  };

  interface LocationDetails {
    areaId: string;
    areaName?: string;
    subDistrictsName?: string;
    districtName?: string;
    stateName?: string;
    countryName?: string;
  }

  const handleLocationFetch = async (pincode: number) => {
    try {
      const fetchedLocationDetails =
        await UserAddressService.getAddress(pincode);
      if (fetchedLocationDetails && fetchedLocationDetails.length > 0) {
        const areasMap = new Map<string, string>();
        const subdistricts = new Set<string>();
        const districts = new Set<string>();
        const pinstate = new Set<string>();
        const pincountry = new Set<string>();

        fetchedLocationDetails.forEach((location: LocationDetails) => {
          if (location.areaId && location.areaName) {
            areasMap.set(location.areaId, location.areaName);
          }

          if (location.subDistrictsName)
            subdistricts.add(location.subDistrictsName);
          if (location.districtName) districts.add(location.districtName);
          if (location.stateName) pinstate.add(location.stateName);
          if (location.countryName) pincountry.add(location.countryName);
        });

        setLocationDetails(fetchedLocationDetails);
        setAreas(
          Array.from(areasMap.entries()).map(([id, name]) => ({ id, name }))
        );

        setSubdistricts(Array.from(subdistricts));
        setDistricts(Array.from(districts));
        setPinState(Array.from(pinstate));
        setPinCountry(Array.from(pincountry));
      } else {
        setLocationDetails(null);
        setAreas([]);
        setSubdistricts([]);
        setDistricts([]);
        setPinState([]);
        setPinCountry([]);
      }
    } catch (error) {
      alert("Failed to fetch location details");
    }
  };

  return (
    <>
      {!isAdmin && (
        <BreadCrumbCustom
          items={breadCrumbItems.items}
          home={breadCrumbItems.home}
          backgroundImage={breadCrumbItems.backgroundImage}
          title={breadCrumbItems.title}
        ></BreadCrumbCustom>
      )}
      <div
        className={
          !isAdmin
            ? "container-fluid Address-form-container layout-content mt-3 mb-3"
            : "container-fluid Address-form-container"
        }
      >
        <div className="col-12">
          {!isAdmin ? (
            <h5 className="mobile-txt-fnt mb-0">
              <Link to={RouteConstant.userAddresses} className="history-title">
                <i className="pi pi-arrow-left"></i>
              </Link>
              &nbsp;&nbsp;&nbsp;&nbsp;{" "}
              {isEdit
                ? t("editaddress_edit_address")
                : t("editaddress_add_address")}
            </h5>
          ) : (
            <h5 className="border-round order-top-color p-2">
              {t("editaddress_add_address")}
            </h5>
          )}
        </div>
        <div className="flex flex-column md:flex-row">
          <div className={`${isAdmin ? "col-12" : "col-9"}`}>
            <Card className="user-address-card border-1 surface-border m-0">
              <form onSubmit={formik.handleSubmit} className="flex flex-column">
                <div className="p-fluid formgrid grid">
                  <div className="field col-12 ">
                    <label htmlFor="addressLine1" className="label-semi-bold">
                      {t("editaddress_address_line_1")}
                      <span className="required">*</span>
                    </label>
                    <span className="p-input-icon-left">
                      <i className="fa-solid fa-home text-area-icon" />
                      <InputTextarea
                        placeholder={t(
                          "editaddress_please_enter_address_line1"
                        )}
                        rows={2}
                        name="addressLine1"
                        id="addressLine1"
                        value={formik.values.addressLine1}
                        onChange={formik.handleChange}
                        className={classNames({
                          "p-invalid": formik.errors.addressLine1,
                        })}
                      />
                    </span>
                    {getFormErrorMessage("addressLine1")}
                  </div>
                  <div className="field col-12 ">
                    <label htmlFor="addressLine2" className="label-semi-bold">
                      {t("editaddress_address_line_2")}
                    </label>
                    <span className="p-input-icon-left">
                      <i className="fa-solid fa-home text-area-icon" />
                      <InputTextarea
                        placeholder={t(
                          "editaddress_please_enter_address_line2"
                        )}
                        rows={2}
                        name="addressLine2"
                        id="addressLine2"
                        value={formik.values.addressLine2}
                        onChange={formik.handleChange}
                        className={classNames({
                          "p-invalid": formik.errors.addressLine2,
                        })}
                      />
                    </span>
                    {getFormErrorMessage("addressLine2")}
                  </div>
                  <div className="field col-12 ">
                    <label htmlFor="landMark" className="label-semi-bold">
                      {t("editaddress_land_mark")}
                    </label>
                    <span className="p-input-icon-left">
                      <i className="fa-solid fa-home text-area-icon" />
                      <InputTextarea
                        placeholder={t("editaddress_please_enter_land_mark")}
                        value={formik.values.landMark || ""}
                        rows={2}
                        name="landMark"
                        id="landMark"
                        onChange={formik.handleChange}
                        className={classNames({
                          "p-invalid": formik.errors.landMark,
                        })}
                      />
                    </span>
                    {getFormErrorMessage("editaddress_land_mark")}
                  </div>
                  <div className="grid col-6">
                    <div className="field col-6 md:col-6">
                      <label htmlFor="pincode">
                        {t("editaddress_pincode")}
                        <span className="required">*</span>
                      </label>
                      <div className="p-inputgroup">
                        <span className="p-input-icon-left">
                          <i className="pi pi-hashtag" />
                          <InputText
                            type="text"
                            name="pincode"
                            id="pincode"
                            placeholder={t("editaddress_please_enter_pincode")}
                            value={formik.values.pincode}
                            onChange={formik.handleChange}
                            className={classNames({
                              "p-invalid": formik.errors.pincode,
                            })}
                            style={{ width: "100%" }}
                          />
                        </span>
                        <Button
                          icon="pi pi-search"
                          severity="success"
                          aria-label="Search"
                          style={{width:'50px'}}
                          onClick={(e) => {
                          e.preventDefault();
                          handleLocationFetch(parseInt(formik.values.pincode));
                          }}
                        />
                      </div>
                      {getFormErrorMessage("pincode")}
                    </div>
                  </div>

                  <div className="form-row">
                    <div className="grid col-12">
                      <div className="col-3">
                        {/* <div className="field"> */}
                        <label htmlFor="area" className="label-semi-bold">
                          Area
                        </label>
                        <Dropdown
                          value={areas.length === 1 ? areas[0].id : formik.values.areaId}
                          options={areas.map((area) => ({
                            label: area.name,
                            value: area.id,
                          }))}
                          onChange={(e) => {
                            formik.setFieldValue("areaId", e.value);
                          }}
                          placeholder="Select Area"
                        />
                      </div>
                      <div className="col-2">
                        <label htmlFor="subdistrict" className="label-semi-bold">
                          Subdistrict
                        </label>
                          <Dropdown
                            value={setDistricts.length === 1 ? subdistricts[0] : setDistricts}
                            onChange={(e) =>
                              formik.setFieldValue("subdistrict", e.value)
                            }
                            options={subdistricts.map((subdistrict) => ({
                              label: subdistrict,
                              value: subdistrict,
                            }))}
                            placeholder="Select SubDistrict"
                            disabled = {true}
                          />
                      </div>
                      <div className="col-2">
                        <label htmlFor="district" className="label-semi-bold">
                          District
                        </label>
                          <Dropdown
                            value={districts.length === 1 ? districts[0] : formik.values.district}
                            onChange={(e) =>
                              formik.setFieldValue("district", e.value)
                            }
                            options={districts.map((district) => ({
                              label: district,
                              value: district,
                            }))}
                            placeholder="Select District"
                            disabled = {true}
                          />
                      </div>
                      <div className="col-2">
                        <label htmlFor="state1" className="label-semi-bold">
                          State
                        </label>
                          <Dropdown
                            value={pinstate.length === 1 ? pinstate[0] : formik.values.selectedState}
                            onChange={(e) =>
                              formik.setFieldValue("state1", e.value)
                            }
                            options={pinstate.map((state) => ({
                              label: state,
                              value: state,
                            }))}
                            disabled = {true}
                          />
                      </div>
                      <div className="col-2">
                        <label htmlFor="country" className="label-semi-bold">
                          Country
                        </label>
                          <Dropdown
                            value={pincountry.length === 1 ? pincountry[0] : selectedCountry}
                            onChange={(e) =>
                              formik.setFieldValue("country", e.value)
                            }
                            options={pincountry.map((country) => ({
                              label: country,
                              value: country,
                            }))}
                            disabled = {true}
                          />
                      </div>
                    </div>
                  </div>
                </div>

                <div className="field col-12 md:col-6">
                  <label></label>
                  <span className="p-inputgroup get-location-btn">
                    <Button
                      type="button"
                      severity="secondary"
                      label={latLngSelected ? "Edit Location" : "Add Location"}
                      icon="fa-solid fa-map-location-dot"
                      value={formik.values.secondary}
                      outlined
                      onClick={() => setIsLocationMapVisible(true)}
                    ></Button>
                  </span>
                </div>
                <div className="col-12 flex justify-content-between">
                  {!isAdmin ? (
                    <div>
                      <Button
                        type="submit"
                        className="bg-primary"
                        label={
                          isEdit
                            ? t("common_update_button")
                            : t("common_add_button")
                        }
                        severity="success"
                      />
                    </div>
                  ) : (
                    <Button
                      type="submit"
                      className="bg-primary w-11rem"
                      label={t("common_add_button")}
                      severity="success"
                    />
                  )}
                </div>
              </form>
            </Card>
          </div>
          {!isAdmin && (
            <div className="col-3 flex bg-light-green justify-content-center ">
              <Image
                width="150"
                src={process.env.PUBLIC_URL + "/assests/images/homelogo.png"}
                alt="Image"
                className="align-self-center align-items-center"
              />
            </div>
          )}
        </div>
      </div>
      <Dialog
        header="Search your location"
        className="location-dialog"
        visible={isLocationMapVisible}
        onHide={() => setIsLocationMapVisible(false)}
        footer={""}
        style={{ width: "50%" }}
      >
        <GetAddressByLocation
          getLatitudeLongitude={updateGpsLocation}
          lat={latitude}
          lng={longitude}
        ></GetAddressByLocation>
      </Dialog>
    </>
  );
};
export default AddOrEditAddressArea;
